import { SortingRule } from 'react-table';
import { atom, selector } from 'recoil';

import { GetExceptionLogsRequest } from 'api';
import { FilterOption } from 'types';
import { addDays } from 'date-fns';
import { ExceptionLog, ExceptionLogDetailsRequest } from 'types/ExceptionLog';

export const exceptionLogsDetailsModalState = atom<boolean>({
  key: 'exceptionLogsDetailsModalState',
  default: false,
});

export const exceptionLogsDetailsState = atom<ExceptionLogDetailsRequest | undefined>({
  key: 'exceptionLogsDetailsState',
  default: undefined,
});

export const exceptionLogsFiltersState = atom<FilterOption[]>({
  key: 'exceptionLogsFilters',
  default: [],
});

export const exceptionLogsStartDateState = atom<Date>({
  key: 'exceptionLogsStartDate',
  default: addDays(new Date(), -7),
});

export const exceptionLogsEndDateState = atom<Date>({
  key: 'exceptionLogsEndDate',
  default: new Date(),
});

export const exceptionLogsOrderByColumnState = atom<string | undefined>({
  key: 'exceptionLogsOrderByColumn',
  default: undefined,
});

export const exceptionLogsOrderByDescendingState = atom<boolean>({
  key: 'exceptionLogsOrderByDescending',
  default: false,
});

export const exceptionLogsPageSizeState = atom<number>({
  key: 'exceptionLogsPageSize',
  default: 10,
});

export const exceptionLogsPageNumberState = atom<number>({
  key: 'exceptionLogsPageNumber',
  default: 1,
});

export const exceptionLogsTextSearchState = atom<string>({
  key: 'exceptionLogsTextSearchState',
  default: '',
});

export const exceptionLogsSortByState = selector<SortingRule<ExceptionLog>[]>({
  key: 'exceptionLogsSortBy',
  get: ({ get }) => {
    const orderByColumn = get(exceptionLogsOrderByColumnState);
    const orderByDescending = get(exceptionLogsOrderByDescendingState);
    return orderByColumn ? [{ id: orderByColumn, desc: orderByDescending }] : [];
  },
});

export const exceptionLogsRequestState = selector<GetExceptionLogsRequest>({
  key: 'exceptionLogsRequest',
  get: ({ get }) => {
    const sortByDesc = get(exceptionLogsOrderByDescendingState);
    const sortByColumn = get(exceptionLogsOrderByColumnState);

    return {
      keyword: get(exceptionLogsTextSearchState),
      startDate: get(exceptionLogsStartDateState)?.toISOString() ?? '',
      endDate: get(exceptionLogsEndDateState).toISOString() ?? '',
      exceptionLogType:
        get(exceptionLogsFiltersState).filter((x) => x.name === 'exceptionLogType')[0]
          ?.selectedItems[0]?.value ?? 'ConsultationException',
      pageSize: get(exceptionLogsPageSizeState),
      pageNumber: get(exceptionLogsPageNumberState),
      ...(sortByColumn && {
        sortBy: sortByColumn,
        sortOrder: sortByDesc ? 'Descending' : 'Ascending',
      }),
    } as unknown as GetExceptionLogsRequest;
  },
});
